export default "<div class=\"block\">\n    <h3 class=\"block__title\">{{title}}</h3>\n    <ng-content></ng-content>\n</div>"